import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TServiceAlertListResponse } from './types';

export function useServiceAlerts() {
  const { data, error, isLoading, mutate } = useSWR<TServiceAlertListResponse>(
    'service-alerts',
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, isLoading, mutate };
}
